module.exports = __webpack_public_path__ + "wf.742810b60e80621815a2.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/wf.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/wf.svg
// module chunks = styles